<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/2">
      <div class="compair-layout--box mb-5">
        <div class="compair-layout--box-header">
          <h2>Kanäle</h2>
          <DataInput
            v-model="channelMetric"
            type="select"
            :options="[
              { code: 'VISITORS', label: 'Besucher' },
              { code: 'VISITORS_UNIQUE', label: 'Einzigartige Besucher' },
              { code: 'APPLICATIONS', label: 'Bewerbungen' },
              { code: 'CALLBACK_REQUESTS', label: 'Personalanfragen' }
            ]"
            placeholder="Metrik"
            name="metric"
            label="Metrik"
            required
          />
          <table class="top-5-table mt-3">
            <tr v-for="channel in topChannels" :key="channel.identifier">
              <th>
                {{ applicantSources[channel.identifier] }}
              </th>
              <td>{{ channel.number }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="vx-col w-full lg:w-1/2">
      <div class="compair-layout--box">
        <div class="compair-layout--box-header">
          <h2>Seiten</h2>
          <DataInput
            v-model="pageMetric"
            type="select"
            :options="[
              { code: 'VISITORS', label: 'Besucher' },
              { code: 'VISITORS_UNIQUE', label: 'Einzigartige Besucher' },
              { code: 'APPLICATIONS', label: 'Bewerbungen' },
              { code: 'CALLBACK_REQUESTS', label: 'Personalanfragen' }
            ]"
            placeholder="Metrik"
            name="metric"
            label="Metrik"
            required
          />
          <table class="top-5-table mt-3">
            <tr v-for="page in topPages" :key="page.identifier">
              <th>
                <a target="_blank" :href="page.identifier">{{
                  page.identifier
                }}</a>
              </th>
              <td>{{ page.number }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";

export default {
  components: {
    DataInput
  },
  props: {
    start: {
      type: Object,
      required: true
    },
    end: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      channelMetric: "VISITORS",

      pageMetric: "VISITORS",
      applicantSources: {}
    };
  },
  apollo: {
    topPages: {
      query: gql`
        query TopPages(
          $start: Time
          $end: Time
          $number: Int!
          $type: TopNType!
          $metric: TopNMetric!
        ) {
          topNInfo(
            number: $number
            start: $start
            end: $end
            type: $type
            metric: $metric
          ) {
            number
            identifier
          }
        }
      `,
      variables() {
        return {
          metric: this.pageMetric,
          type: "PAGE",
          number: 5,
          start: this.start,
          end: this.end
        };
      },
      update: data => data.topNInfo,
      fetchPolicy: "network-only"
    },
    topChannels: {
      query: gql`
        query TopChannels(
          $start: Time
          $end: Time
          $number: Int!
          $type: TopNType!
          $metric: TopNMetric!
        ) {
          topNInfo(
            number: $number
            start: $start
            end: $end
            type: $type
            metric: $metric
          ) {
            number
            identifier
          }
        }
      `,
      variables() {
        return {
          metric: this.channelMetric,
          type: "CHANNEL",
          number: 5,
          start: this.start,
          end: this.end
        };
      },
      update: data => data.topNInfo,
      fetchPolicy: "network-only"
    },
    applicantSources: {
      query: gql`
        query ApplicantSources($page: Int!, $size: Int) {
          applicantSources(page: $page, size: $size) {
            results {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          page: 1,
          size: 1000 //all sources in one response
        };
      },
      update(data) {
        let sources = {};
        for (let source of data.applicantSources.results) {
          sources[source.id] = source.name;
        }
        return sources;
      }
    }
  }
};
</script>
